module.exports = __webpack_public_path__ + "static/media/contact_small.3326ca5d.jpg";